module.exports = __webpack_public_path__ + "img/ci.f385ab70.svg";